import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PayloadDaD from './components/PayloadDaD/PayloadDaD';
import PayloadRenaniaAdap from './components/PayloadRenaniaAdap/PayloadRenaniaAdap';
import Login from './components/Login/Login';
import PayloadRenaniaUniversal from './components/PayloadRenaniaUniversal/PayloadRenaniaUniversal';
import PayloadCoroaSemFim from './components/PayloadCoroaSemFim/PayloadCoroaSemFim';
import TableUsers from './components/TableUsers/TableUsers';
import LoginADM from './components/LoginADM/LoginADM';
import AuthGuard from './guard/Auth';
import User from './components/User/User';
import PayloadEngConica from './components/PayloadEngConica/PayloadEngConica';
import PayloadEngHipoide from './components/PayloadEngHipoide/PayloadEngHipoide';
import Dashboard from './components/Dashboard/Dashboard';
import HomePage from './components/HomePage/HomePage';
import ExpirationModal from './components/ExpirationModal/ExpirationModal';
import { useState } from 'react';

function App() {
  const [showExpirationModal, setShowExpirationModal] = useState(true);

  const ProtectedRoute = ({ children }) => {
    return (
      <>
        {showExpirationModal && <ExpirationModal onClose={() => setShowExpirationModal(false)} />}
        {children}
      </>
    );
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/adm/login" element={<LoginADM />} />

        <Route
          path="/fresuniversal"
          element={
            <AuthGuard>
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            </AuthGuard>
          }
        />
        <Route
          path="/denteadente"
          element={
            <AuthGuard>
              <ProtectedRoute>
                <PayloadDaD />
              </ProtectedRoute>
            </AuthGuard>
          }
        />
        <Route
          path="/renaniaadap"
          element={
            <AuthGuard>
              <ProtectedRoute>
                <PayloadRenaniaAdap />
              </ProtectedRoute>
            </AuthGuard>
          }
        />
        <Route
          path="/renaniauniversal"
          element={
            <AuthGuard>
              <ProtectedRoute>
                <PayloadRenaniaUniversal />
              </ProtectedRoute>
            </AuthGuard>
          }
        />
        <Route
          path="/coroasemfim"
          element={
            <AuthGuard>
              <ProtectedRoute>
                <PayloadCoroaSemFim />
              </ProtectedRoute>
            </AuthGuard>
          }
        />
        <Route
          path="/engconica"
          element={
            <AuthGuard>
              <ProtectedRoute>
                <PayloadEngConica />
              </ProtectedRoute>
            </AuthGuard>
          }
        />
        <Route
          path="/enghipoide"
          element={
            <AuthGuard>
              <ProtectedRoute>
                <PayloadEngHipoide />
              </ProtectedRoute>
            </AuthGuard>
          }
        />
        <Route
          path="/user"
          element={
            <AuthGuard>
              <ProtectedRoute>
                <User />
              </ProtectedRoute>
            </AuthGuard>
          }
        />
        <Route
          path="/adm/users"
          element={
            <AuthGuard>
              <ProtectedRoute>
                <TableUsers />
              </ProtectedRoute>
            </AuthGuard>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
